// extracted by mini-css-extract-plugin
export var inputContainer = "_sr-0";